import axios from 'axios'
import {getToken} from '@/utils/auts';
import { Message } from 'element-ui';
import store from '../store';
import router from '../router';



/**
 * 创建 axios 实例
 * baseURL: api的 base_url
 * timeout: 请求超时时间
 */
const service = axios.create({
  // baseURL: 'http://vg.local.com/api', //本地测式服务器
  // baseURL: 'http://127.0.0.1:8000/index.php/api', //本地测式服务器
  // baseURL: 'https://verygrass.abontest.com/index.php/api', //本地测式服务器
    baseURL: 'https://www.verygrass.mo/index.php/api',
    // baseURL: 'https://test1.verygrass.mo/index.php/api',
    // baseURL: 'http://fw.d1.com/api', // test
    timeout: 30000,
    headers:{
      'Accept':'application/prs.verygrass.v1+json',
    }
})

/**
 * request 拦截器
 * 请求拦截  你发的所有请求都会先在这个里面判断一下  config请求携带回的数据
 */
service.interceptors.request.use(config => {
  if(getToken()){
    config.headers['Authorization'] = 'Bearer ' + getToken()
  }
    return config//请求成功执行
}, error => {//失败执行
    Promise.reject(error)
})

/**
 * response 拦截器  后台返回的东西
 * 后台的响应拦截 请求成功后 后台返回数据给你    返回的所有数据都会在  下面那个拦截里面判断
 * 只有通过了（把值 return 出来）  才会在你写的成功回调函数里面执行
 */
service.interceptors.response.use(
    response => {
      return response
    },
    error => {
      if (error.response.data.status_code === 401) {
        if (router.currentRoute.fullPath === '/signIn') {
          Message({
            message: error.response.data.message,
            type: 'warning',
            duration: 2 * 1000
          })
        } else {
        store.dispatch('FedLogOut').then(() => {
          Message({
            message: '出现错误,请重新登录',
            type: 'warning'
          })
          router.push({
            name:'SignIn'
          })
        })
        }
      } else{
        if(router.currentRoute.path!=="/paymentSuccess")
        Message.error(error.response.data.message);
      }
      return Promise.reject(error)
    }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js